import axios from "axios";
import { InfoCircle } from "iconsax-react";
import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
// import { Link } from "react-router-dom";
import { TagsInput } from "react-tag-input-component";
import { commonConfigs, urls } from "../../../../../config";
import beveatApiStaging from "../../../../api/staging_beveat_api.js";
import beveatApiProduction from "../../../../api/production_beveat_api.js";

const errorIcon = (
  <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
    <InfoCircle className="h-5 w-5 text-red-500" aria-hidden="true" />
  </div>
);

// Accept props for modal control
export default function CreateNavigationAccessModal({ setOpenModal, refreshData }) {
  const [isDisabled, setIsDisabled] = useState(false);
  const [accessName, setAccessName] = useState("");
  const [load, setLoad] = useState(false);

  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
  } = useForm({
    defaultValues: {
      access_name_options: [] // Ensure TagsInput has an initial array
    }
  });

  let createAccessPagesUrl = ``;
  let apiHeaders;
  let apiInstance;

  if (process.env.REACT_APP_ENV === "staging") {
    createAccessPagesUrl = urls.baseUrl + commonConfigs.apiUrls.createAccessPage();
    apiHeaders = commonConfigs.apiHeader;
    apiInstance = beveatApiStaging;
  } else {
    createAccessPagesUrl = urls.prodUrl + commonConfigs.apiUrls.createAccessPage();
    apiHeaders = commonConfigs.prodApiHeader;
    apiInstance = beveatApiProduction;
  }

  const onSubmit = (data) => {
    setIsDisabled(true); // Disable the submit button

    // Format data safely
    const payload = {
      ...data,
      access_name_options: data.access_name_options || []
    };

    apiInstance
      .post(createAccessPagesUrl, payload, { headers: apiHeaders })
      .then((res) => {
        if (res.data.status !== "success") {
          alert("Error creating page");
        } else {
          alert("Success");
          if (refreshData) refreshData(); // Refresh the table
          setOpenModal(false); // Close the modal
        }
      })
      .catch((err) => {
        alert(`Error: ${err}`);
      })
      .finally(() => {
        setIsDisabled(false); // Enable the submit button if there's an error
      });
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none">
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black opacity-40"
        onClick={() => setOpenModal(false)}
      ></div>

      {/* Modal Container */}
      <div className="relative w-full max-w-2xl mx-auto z-50 p-4">
        <div className="bg-white rounded-2xl shadow-xl p-8 flex flex-col w-full outline-none focus:outline-none">

          <div className="flex items-start justify-between mb-6">
            <h3 className="text-xl font-bold text-gray-900">Create Navigation Access</h3>
            <button
              className="text-gray-400 hover:text-gray-600 text-2xl font-bold"
              onClick={() => setOpenModal(false)}
            >
              ×
            </button>
          </div>

          <form onSubmit={handleSubmit(onSubmit)}>
            {/* Access Name */}
            <div className="mb-6">
              <label htmlFor="access_name" className="block text-sm font-medium text-gray-600 mb-2 text-left">
                Access Name
              </label>
              <div className="relative rounded-md shadow-sm">
                <input
                  type="text"
                  className={!errors.access_name
                    ? "block w-full border-gray-300 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md p-2 border bg-white text-black"
                    : "block w-full border-red-300 text-red-900 placeholder-red-900 focus:ring-red-500 focus:border-red-500 sm:text-sm rounded-md p-2 border"
                  }
                  placeholder="Enter Name of Access"
                  {...register("access_name", { required: true })}
                />
                {errors.access_name && errorIcon}
              </div>
            </div>

            {/* Tags Input for Options */}
            <div className="mb-8">
              <label className="block text-sm font-medium text-gray-600 mb-2 text-left">
                Access Name Options
              </label>
              <div className="text-black custom-tags-input">
                <Controller
                  name="access_name_options"
                  control={control}
                  render={({ field }) => (
                    <TagsInput
                      value={field.value}
                      onChange={field.onChange}
                      name="access_name_options"
                      placeHolder="Type and press enter..."
                    />
                  )}
                />
              </div>
            </div>

            {/* Buttons */}
            <div className="flex justify-center space-x-4">
              <button
                type="button"
                onClick={() => setOpenModal(false)}
                className="hover:bg-red-500 text-red-500 hover:text-white border border-red-500 font-bold py-2 px-10 rounded-full transition-all"
                disabled={isDisabled}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="hover:bg-blue-500 text-blue-500 hover:text-white border border-blue-500 font-bold py-2 px-10 rounded-full transition-all"
                disabled={isDisabled}
              >
                {isDisabled ? "Creating..." : "Create"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}